module.exports = __webpack_public_path__ + "assets/checked-blue.806ef549.svg";